import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { isObject } from '@slardar/sdk-template';
import { DEFAULT_SAMPLE_GRANULARITY } from './constants';
export function normalizeInitConfig(config) {
    var plugins = config.plugins || {};
    for (var k in plugins) {
        if (plugins[k] && !isObject(plugins[k])) {
            plugins[k] = {};
        }
    }
    return __assign(__assign({}, config), { plugins: plugins });
}
export function validateInitConfig(config) {
    return isObject(config) && 'bid' in config;
}
export function normalizeUserConfig(config) {
    return __assign({}, config);
}
export function parseServerConfig(serverConfig) {
    var _a;
    if (!serverConfig) {
        return {};
    }
    var sample = serverConfig.sample, user_id = serverConfig.user_id, plugins = serverConfig.plugins, timestamp = serverConfig.timestamp, _b = serverConfig.quota_rate, quota_rate = _b === void 0 ? 1 : _b;
    if (!sample) {
        return {
            userId: user_id,
        };
    }
    var sample_rate = sample.sample_rate, _c = sample.sample_granularity, sample_granularity = _c === void 0 ? DEFAULT_SAMPLE_GRANULARITY : _c, include_users = sample.include_users, _d = sample.rules, rules = _d === void 0 ? [] : _d;
    return {
        userId: user_id,
        sample: {
            include_users: include_users,
            sample_rate: sample_rate * quota_rate,
            sample_granularity: sample_granularity,
            rules: rules.reduce(function (prev, cur) {
                var name = cur.name, enable = cur.enable, sample_rate = cur.sample_rate, conditional_sample_rules = cur.conditional_sample_rules;
                prev[name] = {
                    enable: enable,
                    sample_rate: sample_rate,
                    conditional_sample_rules: conditional_sample_rules,
                };
                return prev;
            }, {}),
        },
        plugins: {
            heatmap: (_a = plugins === null || plugins === void 0 ? void 0 : plugins.heatmap) !== null && _a !== void 0 ? _a : false,
        },
        serverTimestamp: timestamp,
    };
}
//# sourceMappingURL=normalize.js.map